import { isDemoStandEnabled } from '../dev/demoStand'

/**
 * Локальное демо включает раздел по умолчанию, но явное `false` позволяет
 * проверить сценарий до подключения ERP, не выключая весь демо-кабинет.
 */
export const isInventoryFeatureEnabled = (): boolean => {
  if (isDemoStandEnabled()) return true
  const inventoryFlag = import.meta.env.VITE_INVENTORY_ENABLED
  return (
    inventoryFlag === 'true' ||
    (inventoryFlag !== 'false' && import.meta.env.VITE_DEMO_UI === 'true')
  )
}
